var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.79 15.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.32,15.72H1.47A1.47,1.47,0,0,1,0,14.25V7.37A1.47,1.47,0,0,1,1.47,5.9h8.85a1.47,1.47,0,0,1,1.47,1.47v6.88A1.47,1.47,0,0,1,10.32,15.72ZM1.47,6.88A.49.49,0,0,0,1,7.37v6.88a.49.49,0,0,0,.49.49h8.85a.49.49,0,0,0,.49-.49V7.37a.49.49,0,0,0-.49-.49Zm7.87,0a.49.49,0,0,1-.49-.49V3.93a3,3,0,1,0-5.9,0V6.39a.5.5,0,0,1-1,0V3.93a3.94,3.94,0,0,1,7.87,0V6.39A.5.5,0,0,1,9.34,6.88ZM5.9,11.14A1.31,1.31,0,1,1,7.21,9.83h0A1.32,1.32,0,0,1,5.9,11.14Zm0-1.64a.33.33,0,1,0,.32.33A.33.33,0,0,0,5.9,9.5Zm0,3.6a.49.49,0,0,1-.49-.49v-1.8a.49.49,0,0,1,1,0v1.8A.49.49,0,0,1,5.9,13.1Z",
    fill: "#575757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.b1fe265f47c175e7458df378a91982b4.svg";
export { ForwardRef as ReactComponent };